import OutletGate from './screens/auth/OutletGate';
import SectionGate from './screens/auth/SectionGate';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, Outlet, useLocation } from 'react-router-dom';
import { AppShell } from './screens/layouts/AppShell';
import { MobSplash } from './components/mob';
import { useSession } from './auth/useSession';

const LoginScreen = lazy(() => import('./screens/auth/LoginScreen'));
const TablesScreen = lazy(() => import('./screens/tables/TablesScreen'));
const SeatingScreen = lazy(() => import('./screens/tables/SeatingScreen'));
const OrdersScreen = lazy(() => import('./screens/orders/OrdersScreen'));
const OrderScreen = lazy(() => import('./screens/order/OrderScreen'));
const CheckScreen = lazy(() => import('./screens/order/CheckScreen'));
const DoneScreen = lazy(() => import('./screens/order/DoneScreen'));
const KitchenScreen = lazy(() => import('./screens/kitchen/KitchenScreen'));
const MoreScreen = lazy(() => import('./screens/more/MoreScreen'));
const BuffetScreen = lazy(() => import('./screens/buffet/BuffetScreen'));

function LazyBoundary() {
  return (
    <Suspense fallback={<MobSplash />}>
      <Outlet />
    </Suspense>
  );
}

function ProtectedGate() {
  const { isAuthenticated, isBootstrapping } = useSession();
  const location = useLocation();
  if (isBootstrapping) return <MobSplash />;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

function PublicGate() {
  const { isAuthenticated, isBootstrapping } = useSession();
  if (isBootstrapping) return <MobSplash />;
  if (isAuthenticated) return <Navigate to="/tables" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    element: <LazyBoundary />,
    children: [
      {
        element: <PublicGate />,
        children: [{ path: '/login', element: <LoginScreen /> }],
      },
      {
        element: <ProtectedGate />,
        children: [
          {
            // Multi-outlet: choose the outlet before any screen loads.
            element: <OutletGate />,
            children: [
          {
            // The waiter's section (spec 2.41 §12.1a): chosen after the outlet when it has several.
            element: <SectionGate />,
            children: [
          {
            element: <AppShell />,
            children: [
              { index: true, element: <Navigate to="/tables" replace /> },
              { path: 'tables', element: <TablesScreen /> },
              { path: 'tables/:tableId/seat', element: <SeatingScreen /> },
              { path: 'room-service/new', element: <SeatingScreen channel="ROOM_SERVICE" /> },
              { path: 'orders', element: <OrdersScreen /> },
              { path: 'orders/:id', element: <OrderScreen /> },
              { path: 'orders/:id/check', element: <CheckScreen /> },
              { path: 'orders/:id/done', element: <DoneScreen /> },
              { path: 'kitchen', element: <KitchenScreen /> },
              { path: 'buffet', element: <BuffetScreen /> },
              { path: 'more', element: <MoreScreen /> },
              { path: '*', element: <Navigate to="/tables" replace /> },
            ],
          },
            ],
          },
            ],
          },
        ],
      },
    ],
  },
]);
